import { render } from "./ResendDelivery.vue?vue&type=template&id=13fed696&scoped=true&ts=true"
import script from "./ResendDelivery.vue?vue&type=script&lang=ts"
export * from "./ResendDelivery.vue?vue&type=script&lang=ts"

import "./ResendDelivery.vue?vue&type=style&index=0&id=13fed696&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fed696"]])

export default __exports__